module.exports = __webpack_public_path__ + "static/media/RR-delaunay-graphs.454b5482.JPEG";